import { GuidNameCodeModel } from '@abb-procure/data';
import { Component, input } from '@angular/core';
import { Tag } from '../tag/tag.component';

export type HierarchyData = {
  division: GuidNameCodeModel | null;
  hub: GuidNameCodeModel | null;
};

@Component({
  selector: 'procure-hierarchy',
  templateUrl: './hierarchy.component.html',
  styleUrl: './hierarchy.component.scss',
  imports: [Tag],
})
export class Hierarchy {
  readonly hierarchy = input.required<HierarchyData | null>();
}
